<template>
  <div class="order-items">
    <OrderItem
      v-for="({ id, orderIndex, item, isSubscription }, index) in mixedOrderItems"
      :id="id"
      :key="id"
      :item="item"
      :orderIndex="orderIndex"
      :isStockIgnored="ignoreStock"
      :sizeModifier="sizeModifier"
      :isMerging="mergedItemIndex === index"
      :isTransitioning="isTransitioning"
      :isReadOnly="readOnly"
      :isShowingFullGiftCardMsg="showFullGiftCardMsg"
      :isSubscriptionItem="isSubscription"
      :onRemoveItemFromCart="onRemoveItemFromCart"
    />
  </div>
</template>

<script>
import OrderItem, { SIZE_MODIFIERS } from './OrderItem.vue'

export { SIZE_MODIFIERS }

export default {
  name: 'OrderItems',
  components: {
    OrderItem,
  },

  props: {
    items: { type: Array, required: true },
    subscriptionItems: { type: Array, default: () => [] },
    mergedItemIndex: { type: Number, default: -1 },
    isTransitioning: { type: Boolean },
    ignoreStock: { type: Boolean },
    sizeModifier: { type: String },
    readOnly: { type: Boolean },
    onRemoveItemFromCart: { type: Function },
    showFullGiftCardMsg: { type: Boolean },
  },

  computed: {
    mixedOrderItems() {
      return [
        ...this.subscriptionItems.map((item, orderIndex) => ({
          id: item.id,
          orderIndex,
          item,
          isSubscription: true,
        })),
        ...this.items.map((item, orderIndex) => ({ id: Number(item.variantId), orderIndex, item })),
      ]
    },
  },
}
</script>
